import MovingMarker from './MovingMarker';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet'; 
import "./Openmapcss.css"

const OpenMap = ({ markerData,redDotPosition,center }) => {
  
const zoomLevel = 11;  
  
const blueDotIcon = L.divIcon({
  className: 'blue-dot-marker',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

const greyDotIcon = L.divIcon({
  className: 'grey-dot-marker',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});


const redDotIcon = L.divIcon({
  className: 'red-dot-wrapper', 
  iconSize: [15, 15],            
  iconAnchor: [12.5, 12.5],      
  html: '<div class="red-dot-marker-pulsing"></div>'
}); 

return(

     <div style={{ textAlign: 'center' }}> 
     {markerData.length === 0 ? null : (
                    <MapContainer  
                    center={center} 
                    zoom={zoomLevel} 
                    style={{ height: '700px', width: '90%', margin: '20px auto' }}
                    scrollWheelZoom={true}
                    
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        
                        {markerData.map((marker) => (
                            
                            <Marker key={marker.name} position={marker.position} icon={marker.serviced ? greyDotIcon:blueDotIcon } >
                                <Popup>
                                    **{marker.name}** <br />
                                    Lat: {marker.position[0].toFixed(4)} <br />
                                    Lng: {marker.position[1].toFixed(4)}
                                </Popup>
                            </Marker>
                        ))}
                        {redDotPosition.length > 0 ? (
                        <Marker position={redDotPosition} icon={redDotIcon}  > 
                             {/* <Popup>
                                *{currentPosition.unitlabel}* <br /> 
                             </Popup> */}
                        </Marker>  

                         ) : null}

                    </MapContainer>
     )}
                </div>  
)
}

export default OpenMap;